import { Action } from 'redux';
import {
  CREATE_SUBSCRIPTION,
  GET_AVAILABLE_CARDS,
  GET_AVAILABLE_PLANS,
  SET_USER_DEFAULT_PAYMENT_METHOD,
  SET_REFFERALS_ERRORS,
  SET_USER_REFERRAL_INFO,
} from 'actions/actionTypes';
import { ParentUser } from 'types';
import { ComponentProps, ComponentType } from 'react';

export type AvailablePlanInterval = 'month' | 'year';

export type AvailablePlan = {
  id: string;
  name: string;
  description: string;
  interval: AvailablePlanInterval;
};

export type ReferralInfo = {
  requestsSent: number;
  requestsAccepted: number;
  bonusesReceived: number;
} | null;

export type AvailablePaymentMethod<T extends string = 'card'> = {
  id: string;
  default: boolean;
  last4: string;
  type: T;
};

export type ChosenPaymentMethod = AvailablePaymentMethod & { isNew?: boolean };

export type CardSetupIntent = {
  clientSecret: string;
};

export type CardPaymentIntent = {
  clientSecret: string;
};

export type PaymentsState = {
  availablePlans: AvailablePlan[];
  availableCards: AvailablePaymentMethod[];
  referralsErrors: string;
  referralInfo: ReferralInfo;
};

type PayloadAction<A, P> = Action<A> & { payload: P };

type ActionType =
  | PayloadAction<typeof GET_AVAILABLE_PLANS, AvailablePlan[]>
  | PayloadAction<typeof GET_AVAILABLE_CARDS, AvailablePaymentMethod[]>
  | PayloadAction<typeof CREATE_SUBSCRIPTION, ParentUser>
  | PayloadAction<typeof SET_REFFERALS_ERRORS, string>
  | PayloadAction<typeof SET_USER_REFERRAL_INFO, ReferralInfo>
  | PayloadAction<typeof SET_USER_DEFAULT_PAYMENT_METHOD, unknown>;

export type ComponentCallback<
  Component extends ComponentType<any>,
  Action extends keyof ComponentProps<Component>
> = (
  ...params: ComponentProps<Component>[Action] extends (...args: any) => any
    ? Parameters<ComponentProps<Component>[Action]>
    : never
) => any;

const initialState: PaymentsState = {
  availablePlans: [],
  availableCards: [],
  referralsErrors: '',
  referralInfo: null,
};

const update = (state: PaymentsState, slice: Partial<PaymentsState>) => ({
  ...state,
  ...slice,
});

export default (state = initialState, action: ActionType): PaymentsState => {
  switch (action.type) {
    case GET_AVAILABLE_PLANS:
      return update(state, { availablePlans: action.payload });

    case GET_AVAILABLE_CARDS:
      return update(state, { availableCards: action.payload });

    case SET_REFFERALS_ERRORS:
      return update(state, { referralsErrors: action.payload });

    case SET_USER_REFERRAL_INFO:
      return update(state, { referralInfo: action.payload });
    default:
      return state;
  }
};
